<button type="button" class="chat-conv" [class.chat-conv--active]="active" [class.chat-conv--unread]="unread > 0"
  [attr.aria-current]="active ? 'true' : null" (click)="select.emit(conversation)">
  <chat-avatar [src]="conversation.photo" [name]="conversation.name" [size]="48" [status]="presence"></chat-avatar>
  <span class="chat-conv__body">
    <span class="chat-conv__row">
      <span class="chat-conv__name">{{ conversation.name }}</span>
      <i *ngIf="temperature" class="chat-conv__temp" [ngClass]="temperatureIcon + ' chat-conv__temp--' + temperature" role="img"
        [attr.aria-label]="temperatureTip" [ngbTooltip]="temperatureTip" container="body"></i>
      <span *ngIf="time" class="chat-conv__time">{{ time }}</span>
    </span>
    <span class="chat-conv__row chat-conv__row--preview">
      <span class="chat-conv__preview">
        <chat-icon *ngIf="previewIcon" [name]="previewIcon" [size]="12"></chat-icon>
        <span class="chat-conv__preview-text">{{ preview }}</span>
      </span>
      <span *ngIf="unread > 0" class="chat-conv__badge" [class.chat-conv__badge--pulse]="pulse" (animationend)="onPulseEnd()">{{ badgeText }}</span>
    </span>
    <span *ngIf="conversation.propertyReference || tag || waitingText" class="chat-conv__meta">
      <span *ngIf="conversation.propertyReference" class="chat-conv__ref">
        <chat-icon name="home" [size]="11"></chat-icon>{{ conversation.propertyReference }}
      </span>
      <span *ngIf="conversation.propertyReference && conversation.propertyTitle" class="chat-conv__ptitle">{{ conversation.propertyTitle }}</span>
      <span *ngIf="tag" class="chat-conv__tag" [class.chat-conv__tag--team]="!conversation.supervised">{{ tag }}</span>
      <span *ngIf="waitingText" class="chat-conv__wait">{{ waitingText }}</span>
    </span>
  </span>
</button>
